import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Bar } from "@antv/g2plot";
export default {
  name: "OperationChart",
  props: {},
  data: function data() {
    return {
      houseAuditTimeType: "seven",
      loading: false,
      houseAuditBar: null,
      isExcludeCee: false,
      list: [],
      selectLegend: [],
      selectLegendOnly: [],
      flag: false
    };
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    var _this$houseAuditBar;
    (_this$houseAuditBar = this.houseAuditBar) === null || _this$houseAuditBar === void 0 || _this$houseAuditBar.destroy();
  },
  methods: {
    setData: function setData(list) {
      var data = list.flatMap(function (person) {
        return person.taskWorkHours.map(function (task) {
          return {
            adminId: person.adminId,
            adminName: "".concat(person.adminName || person.adminId, "-").concat(person.totalWorkHours, "h"),
            // 格式：总工时+管理员名
            taskName: task.taskName || "",
            oldName: person.adminName || person.adminId,
            workHours: task.workHours || 0,
            count: task.count || 0
          };
        });
      });
      return data;
    },
    getHouseAuditCount: function getHouseAuditCount() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve, reject) {
                  var res, arr;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _this.loading = true;
                        _context.n = 1;
                        return _this.$api.getOperationChartData({
                          cycle: _this.houseAuditTimeType,
                          excludeCee: !_this.isExcludeCee
                        });
                      case 1:
                        res = _context.v;
                        _this.list = _this.setData(res.data);
                        _this.loading = false;
                        resolve(true);
                        if (_this.houseAuditBar) {
                          arr = _this.updateAdminName(_this.list, _this.flag ? _this.selectLegendOnly : _this.selectLegend);
                          _this.houseAuditBar.changeData(arr);
                        } else {
                          _this.houseAuditBar = new Bar(document.getElementById("container-box"), {
                            appendPadding: [10, 10, 10, 10],
                            data: _this.list,
                            isStack: true,
                            xField: "workHours",
                            yField: "adminName",
                            seriesField: "taskName",
                            colorField: "taskName",
                            legend: {
                              position: "top",
                              marker: {
                                symbol: "circle"
                              },
                              items: [{
                                name: '基础房源审核',
                                value: '基础房源审核',
                                marker: {
                                  style: {
                                    fill: '#6E94F3'
                                  }
                                }
                              }, {
                                name: '用户安全',
                                value: '用户安全',
                                marker: {
                                  style: {
                                    fill: '#f2c35d'
                                  }
                                }
                              }, {
                                name: '付费认证审核',
                                value: '付费认证审核',
                                marker: {
                                  style: {
                                    fill: '#B199FF'
                                  }
                                }
                              }, {
                                name: '客诉处理',
                                value: '客诉处理',
                                marker: {
                                  style: {
                                    fill: '#FF7C9C'
                                  }
                                }
                              }, {
                                name: '社区审核',
                                value: '社区审核',
                                marker: {
                                  style: {
                                    fill: '#7ED6A9'
                                  }
                                }
                              }]
                            },
                            yAxis: {
                              label: {
                                offset: 10
                              },
                              tickLine: {
                                alignTick: false
                              }
                            },
                            color: function color(_ref2) {
                              var taskName = _ref2.taskName;
                              var obj = {
                                基础房源审核: "#6E94F3",
                                用户安全: "#f2c35d",
                                客诉处理: "#FF7C9C",
                                付费认证审核: "#B199FF",
                                社区审核: "#7ED6A9"
                              };
                              return obj[taskName] || "#FF7C9C";
                            },
                            tooltip: {
                              fields: ["workHours", "adminName", "taskName", "count"],
                              formatter: function formatter(datum) {
                                return {
                                  name: datum.taskName,
                                  value: datum.workHours + "h  <span style=\"font-size: 10px;min-width: 40px;display: inline-block \">(".concat(datum.count, "\u6B21)</span>")
                                };
                              }
                            },
                            label: {
                              offsetX: 10,
                              position: "middle",
                              // 可配置附加的布局方法
                              layout: [
                              // 柱形图数据标签位置自动调整
                              {
                                type: "interval-adjust-position"
                              },
                              // 数据标签防遮挡
                              {
                                type: "interval-hide-overlap"
                              },
                              // 数据标签文颜色自动调整
                              {
                                type: "adjust-color"
                              }],
                              formatter: function formatter(_ref3) {
                                var workHours = _ref3.workHours;
                                return workHours >= 0.5 ? workHours : "";
                              }
                            }
                          });
                          _this.houseAuditBar.render();
                          _this.houseAuditBar.on("legend-item:click", _this.changeLegend);
                        }
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee2);
      }))();
    },
    updateAdminName: function updateAdminName(data, targetTaskName) {
      var _this2 = this;
      var arr = JSON.parse(JSON.stringify(data));
      // 1. 按adminId分组建立索引
      var adminMap = {};
      arr.forEach(function (item) {
        if (!adminMap[item.adminId]) {
          adminMap[item.adminId] = [];
        }
        adminMap[item.adminId].push(item);
      });
      // 2. 计算每个adminId需要排除的workHours总和
      var excludeSums = {};
      Object.keys(adminMap).forEach(function (adminId) {
        excludeSums[adminId] = adminMap[adminId].filter(function (item) {
          return _this2.flag ? targetTaskName.includes(item.taskName) : !targetTaskName.includes(item.taskName);
        }).reduce(function (sum, item) {
          return (sum * 10000 + item.workHours * 10000) / 10000;
        }, 0);
      });
      // 3. 修改匹配项的adminName
      return arr.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          adminName: "".concat(item.oldName, "-").concat(excludeSums[item.adminId] || 0, "h")
        });
      });
    },
    // 切换图例
    changeLegend: function changeLegend(data) {
      var _data$target,
        _data$target2,
        _this3 = this;
      var origin = ["基础房源审核", "用户安全", "客诉处理", "付费认证审核", "社区审核"];
      var _ref4 = ((_data$target = data.target) === null || _data$target === void 0 || (_data$target = _data$target.cfg) === null || _data$target === void 0 ? void 0 : _data$target.attrs) || {},
        text = _ref4.text;
      var _ref5 = ((_data$target2 = data.target) === null || _data$target2 === void 0 ? void 0 : _data$target2.cfg) || {},
        type = _ref5.type,
        id = _ref5.id;
      //当点击的是图例的 radio 时
      var name = id.split("-")[3];
      var flag = false;
      if (type === "path") {
        var hasName = this.selectLegendOnly.includes(name);
        var otherArr = origin.filter(function (i) {
          return !_this3.selectLegend.includes(i);
        });
        this.selectLegendOnly = hasName ? [] : [name];
        if (hasName) {
          flag = false;
        } else {
          flag = true;
          this.selectLegend = [];
        }
        //selectLegend 单项式处理
        if ((otherArr === null || otherArr === void 0 ? void 0 : otherArr.length) === 1 && name === (otherArr === null || otherArr === void 0 ? void 0 : otherArr[0])) {
          flag = false;
          this.selectLegendOnly = [];
        }
      } else {
        if (this.selectLegendOnly.length) {
          var filterArr = _toConsumableArray(new Set([].concat(_toConsumableArray(this.selectLegendOnly), _toConsumableArray(this.selectLegend))));
          this.selectLegend = origin.filter(function (item) {
            return !filterArr.includes(item);
          });
        }
        this.selectLegendOnly = [];
        if (!this.selectLegend.includes(text || name)) {
          this.selectLegend.push(text || name);
        } else {
          this.selectLegend.splice(this.selectLegend.indexOf(text || name), 1);
        }
      }
      this.flag = flag;
      var arr = this.updateAdminName(this.list, this.flag ? this.selectLegendOnly : this.selectLegend);
      this.$nextTick(function () {
        _this3.houseAuditBar.changeData(arr);
      });
    }
  }
};